export default {
  perPage: 6,
};
